import { useState } from 'react'
import axios from 'axios'

import { getTimeStamp } from 'Utils/FormatDate'

import { useCommentsContext } from './useCommentsContext'

const apiUrl = '/api/internal/comments'

function useComments() {
  const [state, setState] = useState({
    isRequesting: false,
  })

  const {
    userData,
    addComment,
    removeComment: removeCommentContext,
    editComment: editCommentContext,
  } = useCommentsContext()

  function createComment({ token, id, content }) {
    if (token && id && content) {
      setLoading()

      axios
        .post(apiUrl, {
          authenticity_token: token,
          commentable_type: 'Blog::Post',
          commentable_id: id,
          content,
        })
        .then(() => {
          return onCreateCommentSuccess({
            content,
            id: null,
            userData,
          })
        })
        .catch(onRequestFailure)
        .finally(resetLoading)
    }
  }

  function removeComment({ token, id }) {
    if (id && token) {
      setLoading()

      axios
        .delete(`${apiUrl}/${id}`, getRequestHeader(token))
        .then(() => {
          onRemoveCommentSuccess(id)
        })
        .catch(onRequestFailure)
        .finally(resetLoading)
    }
  }

  function editComment({ token, id, content }) {
    if (token && id && content) {
      setLoading()

      axios
        .put(
          `${apiUrl}/${id}`,
          {
            content,
          },
          getRequestHeader(token)
        )
        .then(() => {
          return onEditCommentSuccess({
            content,
            id,
          })
        })
        .catch(onRequestFailure)
        .finally(resetLoading)
    }
  }

  function onRequestFailure() {
    // To do:
    // sentry error here.
  }

  function onRemoveCommentSuccess(id) {
    removeCommentContext(id)
  }

  function onCreateCommentSuccess({ content, id, userData: currentUserData }) {
    const { currentUserId, currentUserUsername, currentUserAvatarUrl } =
      currentUserData

    const newComment = {
      id,
      attributes: {
        content,
        createdAt: getTimeStamp(),
        author: {
          avatarUrl: currentUserAvatarUrl,
          id: currentUserId,
          isAuthor: true,
          username: currentUserUsername,
        },
      },
    }

    addComment(newComment)
  }

  function onEditCommentSuccess({ content, id }) {
    editCommentContext(id, content)
  }

  function resetLoading() {
    setState((prevState) => ({
      ...prevState,
      isRequesting: false,
    }))
  }

  function setLoading() {
    setState((prevState) => ({ ...prevState, isRequesting: true }))
  }

  function getRequestHeader(token) {
    return {
      headers: {
        'X-CSRF-Token': token,
      },
    }
  }

  return {
    ...state,
    createComment,
    removeComment,
    editComment,
  }
}

export { useComments }
